/** Public iOS TestFlight invite. Testers also receive Founding Member status. */
export const IOS_TESTFLIGHT_URL =
  "https://testflight.apple.com/join/9e4AXqTh?utm_source=certlynx&utm_medium=web&utm_campaign=testflight";

/** Public Google Play listing for the CertLynx Android app. */
export const ANDROID_PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.certlynx.app&hl=en_US";
